import { render, staticRenderFns } from "./productlineOfDepartment3.vue?vue&type=template&id=1c4cf538&scoped=true&"
import script from "./productlineOfDepartment3.vue?vue&type=script&lang=js&"
export * from "./productlineOfDepartment3.vue?vue&type=script&lang=js&"
import style0 from "./productlineOfDepartment3.vue?vue&type=style&index=0&id=1c4cf538&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4cf538",
  null
  
)

export default component.exports